import React, { useEffect, useState, useRef } from "react";
import { networkService } from "../../../config/axios";
import CustomTagsInput from "../../../CommonComponents/Tags/CustomTagsInput";

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const KdfFilerForm = ({ triggerApplyFilterEvent, kdfTitleDefault = '' }) => {
  const [kdfTitle, setKdfTitle] = useState(kdfTitleDefault);
  const [kdfTags, setKdfTags] = useState({ name: "", tags: [] });
  const [status, setStatus] = useState("All");
  const [loading, setLoading] = useState(false);
  const [titleSearchList, setTitleSearchList] = useState([]);
  const [tagsSearchList, setTagsSearchList] = useState([]);
  const [noMatchFound, setNoMatchFound] = useState(false); // For displaying "No match found"
  
  const [debouncedKdfTags, setDebouncedKdfTags] = useState(kdfTags?.name);
  
  const [isTitleSelected, setIsTitleSelected] = useState(false);
  const [isTagSelected, setIsTagSelected] = useState(false);
  // tag signature dedupe ke liye
const tagSig = (tagsArr) => (Array.isArray(tagsArr) ? tagsArr.map(t => t.id).sort().join(",") : "");

// last applied ko yaad rakhne ke liye
const lastAppliedTagSigRef = useRef(tagSig([]));


  const debouncedKdfTitle = useDebounce(kdfTitle, 1000);

  // Search for title
  const titleSearch = async () => {
    if (!debouncedKdfTitle || isTitleSelected) return;
    let { data, status } = await networkService(
      `kdfs.json?title=${debouncedKdfTitle}`,
      "GET"
    );
    if (status === 200) {
      setTitleSearchList(data);
    } else {
      setTitleSearchList([]);
    }
  };

  useEffect(() => {
    if (debouncedKdfTitle && !isTitleSelected) {
      titleSearch();
    } else {
      setTitleSearchList([]);
    }
  }, [debouncedKdfTitle, isTitleSelected]);

  useEffect(() => {
  const currentSig = tagSig(kdfTags.tags);
  if (currentSig !== lastAppliedTagSigRef.current) {
    // naya tag add/remove hua — abhi ke tags se apply karo
    applyFilters(undefined, { finalTags: kdfTags.tags });
    lastAppliedTagSigRef.current = currentSig;
  }
}, [kdfTags.tags]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Default form submit रोकने के लिए
      applyFilters(event); // Apply filters on Enter key press
    }
  };

  const handleKdfTitleChange = (e) => {
    setKdfTitle(e.target.value);
    setIsTitleSelected(false); // Reset flag when typing
  };

  const handleTitleSelect = (item) => {
  setKdfTitle(item.title);
  setTitleSearchList([]);
  setIsTitleSelected(true);
  // Immediately apply with the selected title
  applyFilters(undefined, { title: item.title });
};

  // Search for tags
  const tagsSearch = async (tagName) => {
    if (tagName) {
      let { data, status } = await networkService(
        `tags.json?tag_name=${tagName}&items=doc_list`,
        "GET"
      );
      if (status === 200) {
        setTagsSearchList(data);
      } else {
        setTagsSearchList([]);
      }
    } else {
      setTagsSearchList([]);
    }
  };

  useEffect(() => {
    if (debouncedKdfTags) {
      tagsSearch(debouncedKdfTags); // Trigger tags search only when debounced tag name is updated
    }
  }, [debouncedKdfTags]);

  const handleKdfTagsInputChange = (e) => {
    setKdfTags((prev) => ({ ...prev, name: e }));
    setDebouncedKdfTags(e);
    setNoMatchFound(false); // Reset no match found when user types
  };

  // const handleTagSelect = (item) => {
  //   const alreadyExists = kdfTags.tags.some(tag => tag.id === item.id);
  //   if (!alreadyExists) {
  //     setKdfTags((prev) => ({
  //       ...prev,
  //       tags: [...prev.tags, item],
  //     }));
  //   }
  //   setTagsSearchList([]);
  //   setNoMatchFound(false);
  // };
  const handleTagSelect = (item) => {
  const alreadyExists = kdfTags.tags.some(tag => tag.id === item.id);
  const newTags = alreadyExists ? kdfTags.tags : [...kdfTags.tags, item];

  setKdfTags((prev) => ({
    ...prev,
    tags: newTags,
  }));
  setTagsSearchList([]);
  setNoMatchFound(false);
};

  const handleStatusChange = (e) => {
  const newStatus = e.target.textContent;
  setStatus(newStatus);
  // Immediately apply filters using the new status (override)
  applyFilters(undefined, { status: newStatus });
};

  // const applyFilters = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   setTitleSearchList([]); 
  //   setTagsSearchList([]); 
  //   setNoMatchFound(false); 
  
  //   let payload = {};
  //   let finalTags = [...kdfTags.tags]; // use local copy
  
  //   if (debouncedKdfTags) {
  //     const matchingTag = tagsSearchList.find(
  //       tag => tag.name.toLowerCase() === debouncedKdfTags.toLowerCase()
  //     );
  
  //     const alreadyExists = finalTags.some(
  //       tag => tag.name.toLowerCase() === debouncedKdfTags.toLowerCase()
  //     );
  
  //     if (matchingTag && !alreadyExists) {
  //       finalTags.push(matchingTag);
  //       setKdfTags((prev) => ({
  //         ...prev,
  //         tags: finalTags,
  //         name: "", // clear input
  //       }));
  //       setNoMatchFound(false);
  //     } 

  //   }
  
  //   if (kdfTitle !== "") payload["name"] = kdfTitle;
  //   if (status?.toLowerCase() === "published") payload["published"] = true;
  //   else if (status?.toLowerCase() === "unpublished") payload["published"] = false;
  //   else if (status?.toLowerCase() === "private") payload["private_flag"] = true;
  //   else if (status?.toLowerCase() === "public") payload["private_flag"] = false;
  
  //   if (!noMatchFound && finalTags.length > 0) {
  //     payload["tag_ids"] = finalTags.map((tag) => tag.id);
  //   }
  
  //   await triggerApplyFilterEvent(payload);
  //   setLoading(false);
  // };
  

  // ⬇️ replace existing applyFilters with this
const applyFilters = async (e, overrides = {}) => {
  if (e?.preventDefault) e.preventDefault();
  setLoading(true);

  setTitleSearchList([]);
  setTagsSearchList([]);
  setNoMatchFound(false);

  // ---- pick effective values (overrides win over state) ----
  const effectiveStatus = overrides.status ?? status;
  const effectiveTitle  = overrides.title  ?? kdfTitle;

  // Start from tags passed in overrides (e.g., when user clicked a tag),
  // otherwise use state.
  let finalTags = Array.isArray(overrides.finalTags)
    ? [...overrides.finalTags]
    : [...kdfTags.tags];

  // If typing path is used (debouncedKdfTags present) and NO explicit overrides,
  // keep your existing "matchingTag" auto-push logic.
  if (debouncedKdfTags && !overrides.finalTags) {
    const matchingTag = tagsSearchList.find(
      tag => tag.name.toLowerCase() === debouncedKdfTags.toLowerCase()
    );
    const alreadyExists = finalTags.some(
      tag => tag.name.toLowerCase() === debouncedKdfTags.toLowerCase()
    );
    if (matchingTag && !alreadyExists) {
      finalTags.push(matchingTag);
      setKdfTags((prev) => ({
        ...prev,
        tags: finalTags,
        name: "",
      }));
      setNoMatchFound(false);
    }
  }

  // ---- build payload as before, but with effective values ----
  let payload = {};
  if (effectiveTitle !== "") payload["name"] = effectiveTitle;

  if (effectiveStatus?.toLowerCase() === "published") payload["published"] = true;
  else if (effectiveStatus?.toLowerCase() === "unpublished") payload["published"] = false;
  else if (effectiveStatus?.toLowerCase() === "private") payload["private_flag"] = true;
  else if (effectiveStatus?.toLowerCase() === "public") payload["private_flag"] = false;

  if (!noMatchFound && finalTags.length > 0) {
    payload["tag_ids"] = finalTags.map((tag) => tag.id);
  }

  await triggerApplyFilterEvent(payload);
  setLoading(false);
};

  const resetFilters = () => {
    setKdfTitle("");
    setKdfTags({ name: "", tags: [] });
    setStatus("All");
    triggerApplyFilterEvent();
  };

  // Automatically select matching tag if exists
  const autoSelectMatchingTag = () => {
    const matchingTag = tagsSearchList.find(tag => tag.name.toLowerCase() === kdfTags.name.toLowerCase());
    const alreadyExists = kdfTags.tags.some(tag => tag.id === matchingTag?.id);
  
    if (matchingTag && !alreadyExists) {
      setKdfTags(prev => ({
        ...prev,
        tags: [...prev.tags, matchingTag],
        name: "",
      }));
      setNoMatchFound(false);
    } else if (tagsSearchList.length === 0) {
      setNoMatchFound(true);
    }
  };
  

  // useEffect(() => {
  //   if (debouncedKdfTags) {
  //     autoSelectMatchingTag(); // Automatically select the tag if it matches
  //   }
  // }, [debouncedKdfTags, tagsSearchList]);

  return (
    <form className="kdf-main-list">
      <div className="gap-3 d-flex">
        <div className="position-relative w-100">
          <input
            className="kdf-title"
            type="text"
            placeholder="Search here for any KDF"
            value={kdfTitle}
            onChange={handleKdfTitleChange}
            onKeyDown={handleKeyDown} 
          />
          {titleSearchList.length > 0 && (
            <ul className="kdf-title-drop-ul">
              {titleSearchList.map((item, index) => (
                <li
                  key={index}
                  className="cursor-pointer kdf-title-drop-li"
                  onClick={() => handleTitleSelect(item)}
                >
                  {item.title}
                </li>
              ))}
            </ul>
          )}
        <div className="search-container">
          <a
            href=""
            className=""
            onClick={applyFilters}
            disabled={loading}
          >
             <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="none"
                viewBox="0 0 14 14"
                >
                <path
                  fill="#fff"
                  d="m12.911 14-4.9-4.9a4.74 4.74 0 0 1-2.956 1.011q-2.118 0-3.587-1.468Q0 7.175 0 5.056t1.468-3.588T5.056 0t3.587 1.468 1.468 3.588A4.74 4.74 0 0 1 9.1 8.01l4.9 4.9zM5.056 8.556q1.458 0 2.479-1.021 1.02-1.02 1.02-2.48 0-1.458-1.02-2.479-1.02-1.02-2.48-1.02-1.458 0-2.479 1.02-1.02 1.02-1.02 2.48 0 1.458 1.02 2.479 1.02 1.02 2.48 1.02"
                >

                </path>
              </svg>
            {/* {loading ? "Applying Filters" : "Apply Filters"} */}
     </a>
        </div>
        </div>
        <div className="all-btn">
          <div className="dropdown">
            <a
              className="btn btn-secondary dropdown-toggle"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <mask
                    id="mask0_8_1828"
                    width="24"
                    height="24"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                    style={{ maskType: "alpha" }}
                  >
                    <path fill="#D9D9D9" d="M0 0h24v24H0z"></path>
                  </mask>
                  <g mask="url(#mask0_8_1828)">
                    <path fill="#294561" d="M10 18v-2h4v2zm-4-5v-2h12v2zM3 8V6h18v2z"></path>
                  </g>
                </svg>
                &nbsp;
              {status}
            </a>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <li className="dropdown-item" onClick={handleStatusChange}>
                All
              </li>
              <li className="dropdown-item" onClick={handleStatusChange}>
                Published
              </li>
              <li className="dropdown-item" onClick={handleStatusChange}>
                Unpublished
              </li>
              <li className="dropdown-item" onClick={handleStatusChange}>
                Private
              </li>
              <li className="dropdown-item" onClick={handleStatusChange}>
                Public
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="d-flex">
        <div className="d-flex form-group kdf-list-inp">
          <CustomTagsInput
            tags={kdfTags?.tags || []}
            handleRemoveTags={(value) =>
              setKdfTags((prev) => ({ ...prev, tags: value }))
            }
            placeholderText={'KDF tags'}
            autoSubmit={true}
            collapsedWhenHasTags={false}
            triggerKeyDownEvent={(e) => {
              handleKdfTagsInputChange(e);
              handleKeyDown(e);  // ⬅️ यह जोड़ा गया है
            }}
          />
          {tagsSearchList.length > 0 && (
            <ul className="kdf-title-drop-ul">
              {tagsSearchList.map((item, index) => (
                <li
                  key={index}
                  className="cursor-pointer kdf-title-drop-li"
                  onClick={() => handleTagSelect(item)}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
          {noMatchFound && (
            <ul className="kdf-title-drop-ul">
            <li className="no-match kdf-title-drop-li">No match found</li>
            </ul>
          )}
        </div>
        {/* <button
          className="btn btn-info margin-left-15 reset"
          onClick={applyFilters}
          disabled={loading}
        >
          {loading ? "Applying Filters" : "Apply Filters"}
        </button> */}
        <button className="reset-btn" type="button" onClick={resetFilters}>
         <img src="/icons/autorenew.svg"/> Reset Filters
        </button>
      </div>
    </form>
  );
};

export default KdfFilerForm;
